import type { CollectionReference, DocumentData } from 'firebase/firestore'
import {
  collection,
  query,
  where,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { FirestorePayment } from './schema'
import { schema } from './schema'
import { getDocsWithError } from '../../firestore-mobx/fetch'

export * from './schema'

const converter: FirestoreDataConverter<FirestorePayment> = {
  toFirestore: () => {
    throw new Error('Client cannot write FirestorePayment')
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getColRef = (
  firestore: Firestore
): CollectionReference<FirestorePayment, DocumentData> => {
  return collection(firestore, 'payment').withConverter(converter)
}

export const fetchPaymentsForUser = async (
  firestore: Firestore,
  { userId }: { userId: string }
): Promise<Array<FirestorePayment & { id: string }>> => {
  const ref = getColRef(firestore)
  const q = query(ref, where('userId', '==', userId))
  const snapshot = await getDocsWithError(q, 'FetchPaymentsForUserError')

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }))
}
